
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import 'react';
import SvgCloseCircled from '../../icons/legacy/close-circled.svg.js';
import SvgInfo from '../../icons/legacy/info.svg.js';
import SvgDanger from '../../icons/legacy/danger.svg.js';
import SvgSuccess from '../../icons/legacy/success.svg.js';
import SvgWarning from '../../icons/legacy/warning.svg.js';
import { container } from './styles.js';
import { createElement as jsx } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["type", "children", "onClose", "icon"];
var ICONS = {
  info: jsx(SvgInfo, {
    height: 56
  }),
  danger: jsx(SvgDanger, {
    height: 56
  }),
  success: jsx(SvgSuccess, {
    height: 56
  }),
  warning: jsx(SvgWarning, {
    height: 56
  })
};
var Alert = function Alert(_ref) {
  var type = _ref.type,
    children = _ref.children,
    onClose = _ref.onClose,
    Icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  return jsx("div", _extends({
    css: function css(theme) {
      return container(theme, {
        type: type
      });
    }
  }, rest), Icon ? jsx(Icon, {
    height: 56,
    className: "icon",
    "data-testid": "icon"
  }) : jsx("div", {
    className: "icon",
    "data-testid": "icon"
  }, ICONS[type]), jsx("article", null, children), Boolean(onClose) && jsx("button", {
    "aria-label": "Close alert",
    onClick: onClose,
    className: "close-btn"
  }, jsx(SvgCloseCircled, {
    height: 32
  })));
};

export { Alert as default };
//# sourceMappingURL=Alert.js.map
